"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var luxon_1 = require("luxon");
var Ripple_1 = require("../Ripple");
var DatePicker_1 = require("../DatePicker");
var todayDateTime = luxon_1.DateTime.fromJSDate(DatePicker_1.today);
var Day = function (_a) {
    var dateTime = _a.dateTime, isSelected = _a.isSelected, isDayInMonth = _a.isDayInMonth, isDisabled = _a.isDisabled, isBetween = _a.isBetween, isEndTime = _a.isEndTime, isStartTime = _a.isStartTime, isVirtualSelected = _a.isVirtualSelected, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var dayText = dateTime.day;
    if (!isDayInMonth) {
        return React.createElement("div", { className: classnames_1.default(styles.day, styles.disabled) });
    }
    var isToday = dateTime.equals(todayDateTime);
    var isWeekend = dateTime.weekday === 7 || dateTime.weekday === 6;
    return (React.createElement("div", { className: classnames_1.default(styles.day, isDisabled && styles.disabled, isToday && styles.today, isBetween && styles.between, isSelected && styles.selected, isWeekend && styles.weekend, isEndTime && styles.endTime, isStartTime && styles.startTime, isVirtualSelected && styles.virtualSelected), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick },
        dayText,
        React.createElement(Ripple_1.default, null)));
};
exports.default = Day;
